import React, { Dispatch, SetStateAction, useEffect, useState } from "react";
import {
  Controller,
  ControllerRenderProps,
  FieldValues,
  Path,
  UseFormGetValues,
  UseFormSetValue,
} from "react-hook-form";
import ValidateError from "../global/ValidateError";
import { useSelector } from "react-redux";
import { UserSliceType } from "../../lib/redux/slices/userSlice";

import { selectStyle, selectTheme } from "../../styles/selectStyles";

import Select, { GroupBase } from "react-select";
import { useDebounce } from "../../hooks/useDebounce";
import { log } from "node:console";
import PlayerOption from "../global/PlayerOption";
import CustomMenuList from "../global/AddGuestPlayerButton";
import { FetchBaseQueryError } from "@reduxjs/toolkit/query";
import { SerializedError } from "@reduxjs/toolkit";
export type optionsType = {
  [key: string]: string | number | boolean;
};
type Props<T extends FieldValues,nameType extends Path<T>> = {
  field: ControllerRenderProps<T,nameType>;
  setValue: UseFormSetValue<T>;
  name: nameType;
  position?: "auto" | "bottom" | "top";
  valueKey?: string;
  onChange: any;
  index?: number;
  dependOn?: any[];
  isDisabled?: boolean;
  excludedValues?: number[];
  selectedObject?: {
    id: number;
    name: string;
    booking_id?: number;
    isGuest?: boolean;
    price?: number;
  };
  requestFn: any;
  HasMenu?: boolean;
  extraParams?: Object;
  isAllowToAutoUpdate?: boolean;
  turnOff?: boolean;
  onLoading?: () => void;
  numberOfGuestPlayers?: number;
  getValues?: UseFormGetValues<T>;
  onError?: (error: FetchBaseQueryError | SerializedError | undefined) => void;
  hasGuestAction?: boolean;
  isCustomOption?: boolean;
  onSuccess?: (data: any) => void;
  setNumberOfGuestUsers?: Dispatch<SetStateAction<number>>;
  menuActionProps?: Partial<{
    hasAddPlayerBtn: boolean;
    action_type:
      | "new"
      | "view"
      | "duplicate"
      | "add player"
      | "edit-all"
      | "edit";
    type: string;
    booking_id: number;
  }>;
};

function SelectPlayerBox<T extends FieldValues, nameType extends Path<T>>({
  field,
  position,
  turnOff = false,
  setValue,
  getValues,
  excludedValues,
  HasMenu = false,
  menuActionProps = {},
  onLoading,
  isCustomOption = false,
  onError,
  index,
  isDisabled,
  numberOfGuestPlayers = 0,
  hasGuestAction = false,
  onChange,
  isAllowToAutoUpdate,
  requestFn,
  valueKey = "id",
  selectedObject,
  dependOn = [],
  setNumberOfGuestUsers,
  extraParams,
  onSuccess,
}: Props<T, nameType>) {
  const selectedClub = useSelector(
    (state: UserSliceType) => state.user.selectedClub
  );

  // console.log(excludedValues);

  const [query, setQuery] = useState<string>("");
  const debouncedQuery = useDebounce(query);
  const [isHaveGuestPlayer, setIsHaveGuestPlayer] = useState(false);
  const [isEmptyOption, setIsEmptyOption] = useState(false);
  //@ts-ignore
  const [options, setOptions] = useState<optionsType[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const {
    data,
    isSuccess,
    isError,
    refetch,
    isLoading,
    isUninitialized,
    isFetching,
    error,
  } = requestFn(
    { name: debouncedQuery, club_id: selectedClub, ...extraParams },
    { skip: !loading }
  );

  useEffect(() => {
    //   setOptions(selectedServices)
    if (!turnOff) {
      setLoading(true);
      setOptions((prev) => prev.filter((item) => item.id !== 0));
    }

    setIsHaveGuestPlayer(false);
  }, [selectedClub, turnOff, ...dependOn]);
  //  useEffect(() => {
  //   setLoading(true);
  //   // console.log(!isUninitialized );
  //   // console.log(dependOn);

  //   // if(!isUninitialized && isSuccess){
  //   //   console.log('test');
  //   //   if(((isSuccess && data)) && !isLoading && !isError ) {
  //   //     console.log('test');

  //   //     setLoading(true);
  //   //     refetch();
  //   //   }
  //   // }else{
  //   //   if(isError && !turnOff){
  //   //     setLoading(true)
  //   //   }
  //   // }

  //  },[...dependOn])

  useEffect(() => {
    if (isSuccess && data && !isLoading && !isFetching && !isError) {
      const fetchedValues = data.data.map((item: optionsType) => item);
      //@ts-ignore
      if (data.data.length === 0) {
        setIsEmptyOption(true);
      }
      onSuccess && onSuccess(data);
      setOptions((prev) => {
        const newValues = [...prev];
        // fetchedValues.forEach((item: any) => {
        //   const currentItem =newValues.find((existing) => existing.id === item.id )

        //   if (!currentItem) {
        //     newValues.push(item);
        //   }else if(currentItem.price !== item.price){
        //       const index = newValues.findIndex((existing) => existing.id === item.id )
        //       newValues[index] = item
        //   }
        // });
        //@ts-ignore
        const newValuesMap = new Map<string, any>(
          //@ts-ignore
          newValues.map((item) => [item.id, item])
        );

        // Temporary set to track price changes for final validation
        const changedIds = new Set<string>();

        for (const fetchedItem of fetchedValues) {
          const existingItem = newValuesMap.get(fetchedItem.id);

          if (!existingItem) {
            newValuesMap.set(fetchedItem.id, fetchedItem);
          } else if (existingItem.price !== fetchedItem.price) {
            newValuesMap.set(fetchedItem.id, fetchedItem);
            changedIds.add(fetchedItem.id);
          }
        }

        // Convert back to array and preserve original order if needed
        const optimizedNewValues = Array.from(newValuesMap.values());
        const checkIfValueExists = selectedObject
          ? optimizedNewValues.find((item) => item.id === selectedObject?.id)
          : true;
        if (checkIfValueExists) {
          if (isSuccess && optimizedNewValues) {
            const selectedOption = optimizedNewValues.find(
              (item) => item.id === field.value
            );

            if (isAllowToAutoUpdate) {
              onChange &&
                onChange({
                  ...selectedOption,
                });
            }
          }
          return optimizedNewValues;
        } else {
          if (isSuccess && optimizedNewValues) {
            const selectedOption = [...optimizedNewValues, selectedObject].find(
              (item) => item.id === field.value
            );

            if (isAllowToAutoUpdate) {
              if (selectedOption?.isGuest) {
                selectedOption.price =
                  selectedOption.price || data?.standard_price;
              }

              onChange &&
                onChange({
                  ...selectedOption,
                });
            }
          }
          return [...optimizedNewValues, selectedObject];
        }
      });

      //setLoading(false);
      console.log(isSuccess, data, isLoading, isError, isUninitialized);
    }
  }, [isSuccess, data, isLoading, isFetching, isError]);
  useEffect(() => {
    if (isFetching || isLoading) {
      setOptions([]);
    }

    // console.log(field);
    // console.log(onLoading);
  }, [isLoading, isFetching]);
  useEffect(() => {
    console.log(isError);

    if (isError && !isLoading && !isFetching) {
      //setLoading(false);
      console.log("test");
      //@ts-ignore
      setOptions([selectedObject]);
      onError && onError(error);
    }
  }, [isError, isLoading, isFetching]);
  const addGuestPlayer = () => {
    // if(!isHaveGuestPlayer){
    console.log("clicked");

    setOptions((prev) => {
      return [
        {
          id: 0,
          name: query ? query : ` player ${numberOfGuestPlayers + 1}`,
          isGuest: true,
          price: data?.standard_price || 0,
          level: 0,
          email: "Guest player",
        },
        ...prev,
      ];
    });
    setNumberOfGuestUsers && setNumberOfGuestUsers((prev: number) => prev + 1);
    //}

    setIsHaveGuestPlayer(true);
    onChange({
      id: 0,
      name: query ? query : ` player ${numberOfGuestPlayers + 1}`,
      isGuest: true,
      price: data?.standard_price || 0,
      level: 0,
      email: "Guest player",
    });
  };
  useEffect(() => {
    if (query || !isUninitialized) {
      !turnOff && onLoading && onLoading();
      !turnOff && setLoading(true);
    }
  }, [query]);
  return (
    <Select<optionsType, false, GroupBase<optionsType>>
      menuPlacement={position || "auto"}
      components={
        isCustomOption
          ? HasMenu
            ? {
                IndicatorSeparator: () => null,
                Option: PlayerOption,
                MenuList: (props) => (
                  <CustomMenuList
                    {...props}
                    {...menuActionProps}
                    addGuestPlayer={addGuestPlayer}
                    isEmptyOption={isEmptyOption}
                    query={query}
                    
                    hasGuestPlayer={hasGuestAction}
                  />
                ),

                ClearIndicator: () => null,
              }
            : {
                IndicatorSeparator: () => null,
                Option: PlayerOption,
              }
          : {
              IndicatorSeparator: () => null,
            }
      }
      styles={{
        ...selectStyle,
        menuList: (provided) => ({
          ...provided,
          padding: "0",

          maxHeight: "200px",
          overflowY: "auto", // Enables scrolling

          scrollbarWidth: "inherit", // For Firefox
          "&::-webkit-scrollbar": {
            width: "9px",
            height: "15px",
          },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#1E1850", // Scrollbar color
            borderRadius: "10px", // Scrollbar shape
            border: "1px",
            borderStyle: "solid",
            borderColor: "#d8d7d7",
            position: "absolute",
          },
          "&::-webkit-scrollbar-thumb:hover": {
            //backgroundColor: "#555", // Hover color
          },
          "&::-webkit-scrollbar-track": {
            background: "#f3f3f3",
            borderRadius: "10px", // Track color
          },

          "&::-webkit-scrollbar-button": {
            display: "none",
          },
        }),
      }}
      classNamePrefix="react-select "
      theme={selectTheme}
      {...field}
      isDisabled={isDisabled}
      options={
        excludedValues
          ? options.filter(
              (option) =>
                !excludedValues.includes(Number(option?.id)) || option.isGuest
            )
          : options
      }
      getOptionLabel={(option: any) => option.name}
      getOptionValue={(option: any) => option.id}
      onChange={onChange}
       filterOption={(option, inputValue) => {
    const { name, email } = option?.data;
    console.log(option);
    
    return (
      true
      // //@ts-ignore
      // name?.toLowerCase().includes(inputValue.toLowerCase()) ||
      // //@ts-ignore
      // email?.toLowerCase().includes(inputValue.toLowerCase()) 

    )
  }}
      onInputChange={(inputValue, { action }) => {
        if (action === "input-change") {
          console.log(inputValue);

          setQuery(inputValue);
        }
      }}
      isLoading={isLoading || isFetching}
      value={
        options.find((option) => {
          //
          //

          return option?.id === field.value;
        }) || null
      }
      hideSelectedOptions={false}
      isSearchable={true}

      // isClearable={true}
    />
  );
}

export default SelectPlayerBox;
